import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Wrapper from "../Layout/Wrapper";
import LevelBadge from "../LevelBadge";
import StarCounter from "../StarCounter";
import firebase from "firebase";
import { Menu, Dropdown } from "antd";
import useAuth from "../../hooks/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const TopBarWrapper = styled.div`
  height: 96px;
  border-bottom: 2px solid #fafafa;
  nav {
    display: flex;
    height: 100%;
    align-items: center;
    a {
      font-size: 18px;
      text-transform: uppercase;
      margin-right: 32px;
      text-decoration: none;
      color: #666666;
      font-weight: bold;
      &.active,
      &:hover {
        color: var(--orange);
      }
    }
  }

  .profile-picture {
    width: 72px;
    height: 72px;
    margin: 0 8px 0 12px;
    cursor: pointer;
    border-radius: 100%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    overflow: hidden;
    img {
      width: 100%;
    }
  }

  .right {
    display: flex;
  }
`;

const StarTotal = styled.div`
  background: #fafafa;
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

const TopBar = () => {
  const { accountDetails, imageUrl } = useAuth();
  const currStars =
    accountDetails?.awards?.reduce((stars, aw) => stars + aw.stars, 0) || 0;
  return (
    <TopBarWrapper>
      <Wrapper style={{ justifyContent: "space-between" }}>
        <nav>
          <NavLink to="/" exact>
            Home
          </NavLink>
          <NavLink to="/calendar">Calendar</NavLink>
          <NavLink to="/leaderboard">Leaderboard</NavLink>
        </nav>
        <div className="right">
          <StarTotal>
            <StarCounter stars={currStars} />
          </StarTotal>

          <LevelBadge
            stars={currStars}
            style={{
              height: 92,
              width: 92,
              marginLeft: 16,
              cursor: "pointer",
            }}
          />
          <Dropdown
            trigger={["click"]}
            overlay={
              <Menu>
                <Menu.Item>
                  <NavLink to="/profile">Your profile</NavLink>
                </Menu.Item>
                <Menu.Item onClick={() => firebase.auth().signOut()}>
                  Logout
                </Menu.Item>
              </Menu>
            }
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="profile-picture">
                <img src={imageUrl} alt="Your profile" />
              </div>
              <FontAwesomeIcon
                icon={faChevronDown}
                style={{ alignSelf: "center " }}
              />
            </div>
          </Dropdown>
        </div>
      </Wrapper>
    </TopBarWrapper>
  );
};

export default TopBar;
